<template>
  <div>
    <div class="header-wrapper">
      <h2>Customer Reviews</h2>

      <StarRating
        :rating="lender.scoreAverage"
        :editable="false"
        :size="26"
        justify="flex-start">
        <template #label>
          <span v-if="$vuetify.breakpoint.lgAndUp">{{ reviewCountLabel }}</span>
          <span v-else>
            {{ (lender.scoreAverage || 0).toFixed(1) }} out of 5
          </span>
        </template>
      </StarRating>

      <p v-if="$vuetify.breakpoint.mdAndDown" class="subdued" >
        {{ reviewCountLabel }}
      </p>
    </div>

    <div class="grid-wrapper">
      <Review
        v-for="review in reviews"
        :key="review.id"
        :review="review"
        :lenderTitle="lender.title" />
    </div>

    <button
      v-if="areMoreReviews"
      class="default-btn link small"
      @click="loadReviews"
    >Load More</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Review from './Review'

export default {
  name: 'CustomerReviews',
  components: {
    Review,
  },
  props: {
    dealId: String,
    hasBeenContacted: Boolean,
    lender: Object,
  },
  data: () => ({
    reviews: [],
    reviewOffset: 0,
    reviewTotal: 0,
  }),
  computed: {
    ...mapGetters('feathers', ['apiReviews']),

    areMoreReviews () {
      return this.reviews.length < this.reviewTotal
    },

    reviewCountLabel () {
      const count = this.lender.reviewCount

      return this.$vuetify.breakpoint.mdAndDown
        ? `${count} customer review${count !== 1 ? 's' : ''}`
        : `(${count} review${count !== 1 ? 's' : ''})`
    },
  },
  created () {
    this.loadReviews()
  },
  methods: {
    async loadReviews () {
      const { data, limit, skip, total } = await this.apiReviews.find({
        query: {
          productId: this.lender.id,
          $skip: this.reviewOffset,
          $paginate: true,
          $include: { User: true },
        },
      })

      this.reviews.push(...data)
      this.reviewOffset = skip + limit
      this.reviewTotal = total
    },
  },
}
</script>

<style lang="scss" scoped>
.default-btn.link {
  font-size: 20px;
}

.header-wrapper {
  display: grid;

  grid-template-columns: 1fr;
  grid-row-gap: 10px;
  justify-content: flex-end;
  align-items: flex-end;

  margin-bottom: 36px;

  .rating-wrapper {
    flex-shrink: 0;
    span { padding-left: 10px; }
  }

  p {
    margin: 0;
  }

  @include lg {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
}

h2 {
  color: $textDarkMuted;
}

.grid-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;

  margin-bottom: 20px;

  & > * {
    border-top: 1px solid #CBCBCB;

    &:last-child {
      border-bottom: 1px solid #CBCBCB;
    }
  }
}
</style>
